import React from 'react';

interface Payload { total?: number; done?: number; pending?: number; }

export default function TaskCounter({ data }: { data: unknown }) {
  const d = (data ?? {}) as Payload;
  const pending = d.pending ?? (d.total != null && d.done != null ? d.total - d.done : null);
  const wrapSt: React.CSSProperties  = { height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' };
  const labelSt: React.CSSProperties = { fontSize: 12, color: 'var(--tg-theme-hint-color)', margin: 0 };
  const numSt: React.CSSProperties   = { fontSize: 42, fontWeight: 700, lineHeight: 1, margin: 0, color: 'var(--tg-theme-accent-text-color)' };
  const subSt: React.CSSProperties   = { fontSize: 12, color: 'var(--tg-theme-hint-color)', margin: '4px 0 0', opacity: 0.7 };
  const totalSt: React.CSSProperties = { fontSize: 11, color: 'var(--tg-theme-hint-color)', margin: 0, opacity: 0.5 };
  return (
    <div style={wrapSt}>
      <p style={labelSt}>Задачи</p>
      <div>
        <p style={numSt}>{pending ?? '—'}</p>
        <p style={subSt}>активных</p>
      </div>
      {d.total != null && <p style={totalSt}>всего: {d.total}</p>}
    </div>
  );
}
